export function setUser(data) {
    return { type: "SET_USER", user: data }
}
